module.exports = __webpack_public_path__ + "assets/images/logo-new_ed2087aa7fbc4adc7f6559a13fe8fc78.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/logo-new.png
// module id = 966
// module chunks = 0